<template>
  <b-modal
    id="modalRemoveUserSettings"
    centered
    title="Remover Settings"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <b-tabs v-model="tabIndex" pills justified>
      <b-tab title="Delete User Settings">
        <div class="mb-3 mt-3">
          <label for="id" class="form-label">ID da settings</label>
          <b-form-input
            id="id"
            v-model="formSettings.id"
            placeholder="Digite o ID"
            type="number"
            :state="!errorsSettings.id"
          />
          <b-form-invalid-feedback v-if="errorsSettings.id">
            {{ errorsSettings.id }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="user_id" class="form-label">ID do Usuário</label>
          <b-form-input
            id="user_id"
            v-model="formSettings.user_id"
            placeholder="Digite o ID do usuário"
            type="number"
            :state="!errorsSettings.user_id"
          />
          <b-form-invalid-feedback v-if="errorsSettings.user_id">
            {{ errorsSettings.user_id }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>

      <b-tab title="Delete User Flags">
        <div class="mb-3 mt-3">
          <label for="flag_id" class="form-label">ID da Flag</label>
          <b-form-input
            id="flag_id"
            v-model="formFlags.flag_id"
            placeholder="Digite o ID da flag"
            type="number"
            :state="!errorsFlags.flag_id"
          />
          <b-form-invalid-feedback v-if="errorsFlags.flag_id">
            {{ errorsFlags.flag_id }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="flag_user_id" class="form-label">ID do Usuário</label>
          <b-form-input
            id="flag_user_id"
            v-model="formFlags.user_id"
            placeholder="Digite o ID do usuário"
            type="number"
            :state="!errorsFlags.user_id"
          />
          <b-form-invalid-feedback v-if="errorsFlags.user_id">
            {{ errorsFlags.user_id }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>
    </b-tabs>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="danger" @click="submitData">Remover</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import OperationsService from '@services/resources/OperationsService';

const service = OperationsService.build();

export default {
  name: 'modalRemoveUserSettings',
  data() {
    return {
      tabIndex: 0,
      formSettings: {
        id: '',
        user_id: '',
      },
      formFlags: {
        flag_id: '',
        user_id: '',
      },
      errorsSettings: {},
      errorsFlags: {},
    };
  },
  methods: {
    validateSettings() {
      this.errorsSettings = {};

      if (!this.formSettings.id.toString().trim()) {
        this.errorsSettings.id = 'O campo ID é obrigatório.';
      }

      if (!this.formSettings.user_id.toString().trim()) {
        this.errorsSettings.user_id = 'O campo ID do Usuário é obrigatório.';
      }

      return Object.keys(this.errorsSettings).length === 0;
    },

    validateFlags() {
      this.errorsFlags = {};

      if (!this.formFlags.flag_id.toString().trim()) {
        this.errorsFlags.flag_id = 'O campo ID da Flag é obrigatório.';
      }

      if (!this.formFlags.user_id.toString().trim()) {
        this.errorsFlags.user_id = 'O campo ID do Usuário é obrigatório.';
      }

      return Object.keys(this.errorsFlags).length === 0;
    },

    async submitData() {
      if (this.tabIndex === 0) {
        if (!this.validateSettings()) return;

        const url = `/remove-user-settings/${Number(this.formSettings.id)}/${Number(this.formSettings.user_id)}`;
        try {
          await service.delete(url);
          this.$bvToast.toast('Configurações removidas com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
          });
          this.$bvModal.hide('modalRemoveUserSettings');
          this.resetForm();
        } catch (error) {
          this.handleError(error);
        }
      } else {
        if (!this.validateFlags()) return;

        const url = `/remove-user-flag/${Number(this.formFlags.flag_id)}/${Number(this.formFlags.user_id)}`;
        try {
          await service.delete(url);
          this.$bvToast.toast('Flag removida com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
          });
          this.$bvModal.hide('modalRemoveUserSettings');
          this.resetForm();
        } catch (error) {
          this.handleError(error);
        }
      }
    },

    handleError(error) {
      let message = 'Erro ao enviar';

      if (
        error.response &&
        typeof error.response.data === 'string'
      ) {
        const parsed = JSON.parse(error.response.data);
        if (parsed.errors) {
          message = Object.values(parsed.errors).flat().join('\n');
        } else if (parsed.message === 'User setting not found or already removed.') {
          message = 'Configuração de usuário não encontrada ou já removida.';
        } else if (parsed.message) {
          message = parsed.message;
        }
      } else if (
        error.response &&
        typeof error.response.data === 'object' &&
        error.response.data.message
      ) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      this.$bvToast.toast(message, {
        title: 'Erro',
        variant: 'danger',
        solid: true,
      });
    },

    resetForm() {
      this.formSettings = {
        id: '',
        user_id: '',
      };
      this.formFlags = {
        flag_id: '',
        user_id: '',
      };
      this.errorsSettings = {};
      this.errorsFlags = {};
    },
  },
};
</script>
